import React from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
const META_PIXEL_ID = '790333870788238'
/**
 * Meta Pixel — single, idempotent installation.
 * Runs once at module load (outside React) so it can never fire twice,
 * even if the app re-renders or an effect runs twice in dev.
 */;
(function installMetaPixel() {
  if (typeof window === 'undefined') return;
  const w = window as any;
  if (w.__aulaMaterPixelLoaded) return;
  w.__aulaMaterPixelLoaded = true;
  const n: any = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
  };
  if (!w.fbq) {
    w.fbq = n;
    if (!w._fbq) w._fbq = n;
    n.push = n;
    n.loaded = true;
    n.version = '2.0';
    n.queue = [];
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://connect.facebook.net/en_US/fbevents.js';
    (document.head || document.body || document.documentElement).appendChild(script);
  }
  w.fbq('init', META_PIXEL_ID);
  w.fbq('track', 'PageView');
})();
render(<App data-id="element-351" data-mp="1anjc7jlqy1ty" />, document.getElementById('root'));